module.exports = __webpack_public_path__ + "img/arrow-circle-up-left.1e096586.svg";